import { createCardElement } from './card-renderer.js';

let handContentElement = null;
let selectedCardIndices = []; // Track selection state in this module

export function initHand(handElement) {
  if (!handElement) {
    console.error("KridaUIHand: Hand content element not provided during initialization.");
    return;
  }
  handContentElement = handElement;
  console.log("KridaUIHand: Initialized with hand element:", handContentElement);
}

// Update hand - called from krida-main.js or krida-ui.js
export function updateHand(myHand, externalSelectedIndices = [], isMyTurn = false) {
  // Always use external selection when provided (even if empty array)
  // Only fall back to internal state if external selection is not provided at all
  const currentSelectedIndices = externalSelectedIndices !== undefined ? externalSelectedIndices : selectedCardIndices;
  
  // Update internal state to match external state when provided
  if (externalSelectedIndices !== undefined) {
    selectedCardIndices = [...externalSelectedIndices];
  }
  
  if (!handContentElement) {
    console.error("Hand content element not initialized or not found");
    return;
  }
  
  const handContent = handContentElement; 

  console.log(`KridaUIHand.updateHand called:`, {
    hasHand: !!myHand,
    handLength: myHand ? myHand.length : 0,
    isMyTurn: isMyTurn,
    selectedIndices: currentSelectedIndices,
    externalProvided: externalSelectedIndices !== undefined
  });
  
  handContent.innerHTML = ''; // Clear previous hand
  handContent.classList.toggle('not-my-turn', !isMyTurn);

  if (!myHand || myHand.length === 0) {
      handContent.innerHTML = '<div class="empty-hand-message">Hand is empty</div>';
      return;
  }
  
  const handContainer = document.createElement('div');
  handContainer.className = 'hand-cards-container';
  handContainer.style.display = 'flex'; 
  handContainer.style.flexWrap = 'wrap';
  handContainer.style.justifyContent = 'flex-start';
  handContainer.style.padding = '5px';
  
  myHand.forEach((card, index) => {
    let cardElement = createCardElement(card);
    cardElement.dataset.cardIndex = index; 
    
    if (currentSelectedIndices.includes(index)) {
      cardElement.classList.add('selected');
    }
    
    // Click listener for card selection
    cardElement.addEventListener('click', function(e) {
      console.log(`KridaUIHand: Card clicked at index ${index}`);
      
      // Toggle selection in this module
      if (selectedCardIndices.includes(index)) {
        selectedCardIndices = selectedCardIndices.filter(i => i !== index);
      } else {
        selectedCardIndices = [index]; // Only allow one card selection
      }
      
      // Update the visual selection immediately
      const allCards = handContainer.querySelectorAll('.card');
      allCards.forEach(card => card.classList.remove('selected'));
      if (selectedCardIndices.length > 0) {
        allCards[selectedCardIndices[0]]?.classList.add('selected');
      }
      
      // Dispatch event to notify main of selection change
      const selectEvent = new CustomEvent('krida-hand-selection-changed', {
        bubbles: true,
        cancelable: true,
        detail: {
          selectedIndices: [...selectedCardIndices],
          cardIndex: index,
          card: card
        }
      });
      
      cardElement.dispatchEvent(selectEvent);
    });
    
    // Double-click listener for SOW action
    cardElement.addEventListener('dblclick', function(e) {
      const datasetIndex = cardElement.dataset.cardIndex;
      const indexToUse = datasetIndex !== undefined ? parseInt(datasetIndex) : index;
      
      console.log(`KridaUIHand: Double-click detected on card at index ${indexToUse} (originalIndex: ${index}, dataset: ${datasetIndex})`);
      
      if (indexToUse === undefined || isNaN(indexToUse) || indexToUse < 0 || indexToUse >= myHand.length) { 
        console.error("KridaUIHand: Invalid or out-of-bounds card index for double-click sow event:", indexToUse);
        return;
      }
      
      const clickedCard = myHand[indexToUse];
      if (!clickedCard) {
           console.error(`KridaUIHand: Could not find card data for index ${indexToUse}`);
           return;
      }

      console.log("KridaUIHand: Processing double-click sow action for card:", {
        cardIndex: indexToUse,
        cardValue: clickedCard.value, 
        cardSuit: clickedCard.suit    
      });

      // Removed first turn hidden card check logic - assumes hand cards are always visible

      // --- Trigger sow action using Custom Event --- 
      // This is the preferred method for decoupling UI from main logic.
      // Krida-main.js should listen for this event.
      try {
        console.log("KridaUIHand: Dispatching 'krida-sow-card' event");
        const sowEvent = new CustomEvent('krida-sow-card', {
          bubbles: true, // Allow event to bubble up
          cancelable: true, // Allow prevention
          detail: {
            cardIndex: indexToUse,
            card: clickedCard // Pass the card data
          }
        });
        
        // Dispatch the event from the clicked element itself or the hand container
        const dispatched = cardElement.dispatchEvent(sowEvent);
        if (!dispatched) {
            console.log("KridaUIHand: Sow event was cancelled.");
        }
      } catch (error) {
        console.error("KridaUIHand: Error dispatching sow event:", error);
      }
      // --- End Event Dispatch --- 
      
      // Removed direct calls to KridaMain/KridaMainFunctions and button simulation
      
      e.preventDefault(); // Prevent default double-click behavior (e.g., text selection)
    });
    
    handContainer.appendChild(cardElement);
  });
  
  handContent.appendChild(handContainer);
  console.log("KridaUIHand: Hand updated with", myHand.length, "cards");
}

// Removed redundant renderHand function 